import React from 'react';

export type DocumentsView = 'records' | 'search' | 'bookmarks';

interface DocumentsViewSwitcherProps {
  activeView: DocumentsView;
  onViewChange: (view: DocumentsView) => void;
  bookmarkCount?: number;
}

const views: { key: DocumentsView; label: string }[] = [
  { key: 'records', label: 'Records' },
  { key: 'bookmarks', label: 'Bookmarks' },
];

export const DocumentsViewSwitcher: React.FC<DocumentsViewSwitcherProps> = ({
  activeView,
  onViewChange,
  bookmarkCount = 0,
}) => {
  // Don't show the "search" pill — search view activates automatically via query input
  const effectiveView = activeView === 'search' ? 'records' : activeView;

  return (
    <div className="flex items-center gap-1 px-3 py-1.5">
      {views.map(({ key, label }) => (
        <button
          key={key}
          onClick={() => onViewChange(key)}
          className={`px-2.5 py-1 text-[11px] font-medium rounded-full transition-colors ${
            effectiveView === key
              ? 'bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300'
              : 'text-medical-500 dark:text-medical-400 hover:bg-medical-100 dark:hover:bg-medical-700/50'
          }`}
        >
          {label}
          {key === 'bookmarks' && bookmarkCount > 0 && (
            <span className="ml-1 px-1 py-0.5 text-[9px] rounded-full bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">
              {bookmarkCount}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};
